import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import { apiAxios } from '@/apiAxios';
import { IApiResponseLogin } from '@/interfaces';
import * as localStorageHelper from '@/localStorageHelper';
import store from '@/store/store';

@Module({ dynamic: true, store, name: 'AdminCredentialModule', namespaced: true })
export default class AdminCredentiaModule extends VuexModule {
  public jwt = localStorage.adminJwt || '';

  @Mutation
  public setAdminJwt(newJwt: string) {
    this.jwt = newJwt;
    localStorageHelper.jwt.save(this.jwt);
  }

  @Action
  public async apiAdminLogin(arg: { loginname: string; password: string }): Promise<IApiResponseLogin> {
    try {
      const { loginname, password } = arg;
      const response = await apiAxios.post<IApiResponseLogin>('api/authenticate', { loginname, password });
      if (response.data.success === true) {
        this.setAdminJwt(response.data.payload.token);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
